import React from "react";
import { useInView } from "@/hooks/useInView";

const Reveal = ({
  children,
  delay = 0,
  y = 24,
  duration = 700,
  className = "",
  as: Tag = "div",
  testId,
}) => {
  const [ref, inView] = useInView({ threshold: 0.15 });

  const style = {
    transform: inView ? "translate3d(0,0,0)" : `translate3d(0, ${y}px, 0)`,
    opacity: inView ? 1 : 0,
    transition: `transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms, opacity ${duration}ms ease-out ${delay}ms`,
    willChange: "transform, opacity",
  };

  return (
    <Tag ref={ref} style={style} className={className} data-testid={testId}>
      {children}
    </Tag>
  );
};

export default Reveal;
